// src/components/Hero.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import Suggestions from "./Suggestions";
import teamCover from "../images/scaimage2.jpeg";

const Hero = () => (
  <section className="mt-6 px-4">
    <div className="relative min-h-[30rem] w-full overflow-hidden rounded-xl shadow-xl md:min-h-[34rem]">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${teamCover})` }}
      />

      <div className="absolute inset-0 bg-gradient-to-r from-sky-950/95 via-sky-950/82 to-sky-950/52" />

      <div className="relative z-10 flex min-h-[30rem] max-w-4xl flex-col justify-center px-6 py-12 text-white sm:px-10 md:min-h-[34rem] md:px-16">
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-sky-200 sm:text-base">
          Connect · Collaborate · Catalyze Results
        </p>

        <h1 className="mt-4 text-4xl font-extrabold leading-tight sm:text-5xl md:text-6xl">
          The Sand Cherry Application
        </h1>

        <p className="mt-5 max-w-3xl text-lg leading-8 text-slate-100 sm:text-xl">
          Sand Cherry is a team of experienced consultants who turn complex business initiatives into practical, high-impact results. Our people bring deep expertise across strategy, data, digital transformation, project leadership, and customer experience.
        </p>

        <p className="mt-3 max-w-3xl text-base leading-7 text-slate-200 sm:text-lg">
          Use this application to connect with fellow Cherries, explore our nationwide team, and stay current on company programs and opportunities to serve together.
        </p>

        <div className="mt-7 flex flex-wrap gap-3">
          <NavLink to="/directory" className="rounded-full bg-white px-5 py-2.5 font-bold text-sky-950 transition hover:bg-sky-100">
            Explore the Directory
          </NavLink>
          <NavLink to="/map" className="rounded-full border border-white/70 bg-white/10 px-5 py-2.5 font-bold text-white transition hover:bg-white/20">
            View the Cherry Map
          </NavLink>
          <NavLink to="/schedule" className="rounded-full border border-white/70 bg-white/10 px-5 py-2.5 font-bold text-white transition hover:bg-white/20">
            Month of Service
          </NavLink>
        </div>

        <div className="mt-7">
          <Suggestions />
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
